import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { DrillsService, GetDrillsListResponse } from '@drills/infra';
import { toDrillViewModel } from '../../../mappers';
import { DrillsListQueryResult } from './drills-list.query-result';

export class DrillsListQueryHandler {
  private readonly drillsService: DrillsService = inject(DrillsService);

  query(): Observable<DrillsListQueryResult> {
    return this.drillsService.getList().pipe(map((res: GetDrillsListResponse) => this.toResult(res)));
  }

  private toResult(res: GetDrillsListResponse): DrillsListQueryResult {
    return {
      all: res.all.map(toDrillViewModel),
      recent: res.recent.map(toDrillViewModel),
      favorites: res.favorites.map(toDrillViewModel)
    };
  }
}
